import React from 'react'
import { Updater, componentDidCatch, browserRouter, fromJSX, IOWidget, stateful, Widget } from 'widgets-for-react'
import { any } from '../../../Shared/Frontend/combinators/any'
import { CurrentPage } from '../../../Shared/Frontend/utils/routes.shared'
import { application } from '../allIncludedModules'
import { Pages } from '../routes/routes.state'
import { routes } from '../routes/routes.widget'
import { RootLayout } from './root.layout'
import { initialRootState, State } from './root.state'
import { renderReadSpeaker } from '../cms/cmsPage.widget'

export const page: IOWidget<State, Updater<State>> = (currentState) =>
  componentDidCatch(currentState.page.kind, pageSwitch(currentState), (error) =>
    fromJSX((_) => <RootLayout.Error kind='notFound' showReadspeaker={renderReadSpeaker(currentState)} />)
  )

function pageSwitch(currentState: State): Widget<Updater<State>> {
  const w = application.tryPageSwitch<State, Pages>(currentState)
  if (w != undefined) return w
  console.error("No page found for", currentState.page)
  return fromJSX(() => <></>)
}

// Full-screen pages don't use the root header and footer
export const isFullScreenPage = (pagekind: CurrentPage<Pages>['kind'], isLoggedIn: boolean) => {
  const pages: Array<CurrentPage<Pages>['kind']> = [
    'preview',
    'drupal',
    'search',
    "storyOverview",
    "newsOverview",
  ]
  return pages.includes(pagekind)
}

export const root = () => browserRouter()(
  stateful()<State>(currentState =>
    any([
      routes(),
      page(currentState)
    ])
  )(initialRootState())
)
